import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@views/layout/index.vue";
import { decryptData } from "@/utils/AES.js";
import qs from "qs"

import storage from '@/utils/localStorage'
import store from "@/store";
Vue.use(VueRouter);

const NotFound = () => import("@/views/404");

const routes = [
  { path: "/", name: "Home", component: () => import("@views/Home.vue") }, // 默认页面
  { path: "/login", name: "Login", component: () => import("@views/Login.vue") }, // 默认页面
  
    // {
    //     path: '/',
    //     redirect: "/home",
    //     //meta可以不写
    //     children: [
    //         {
    //           path: "/home",
    //           name: "首页",
              
    //           meta: {},
    //           component: () =>
    //             import(/* webpackChunkName: "home" */ "../views/Home.vue"),
    //         },
    //         {
    //             path: "/linput",
    //             name: "填写材料",
                
    //             meta: {},
    //             component: () =>
    //               import(/* webpackChunkName: "home" */ "../views/Linput.vue"),
    //         },
    //         {
    //             path: "/pagePf",
    //             name: "配方页面",
                
    //             meta: {},
    //             component: () =>
    //               import(/* webpackChunkName: "home" */ "../views/page-pf.vue"),
    //           },
    //     ]
    // },
   

  { path: "*", component: NotFound }, // 404
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(to)
  // let token = localStorage.getItem('token')
  // console.log('token', to.query)
  // const params = to.query;
  // console.log(to.meta.requireAuth)
  // if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
  //   console.log('to.meta.requireAuth')
  //   if (params.sign) { // 通过vuex state获取当前的token是否存在
  //     console.log(params.sign)
  //     localStorage.setItem('userInfo', params.sign.split('|')[0])
  //     localStorage.setItem('userId', params.sign.split('|')[1])
  //     localStorage.setItem('token', params.sign.split('|')[2])
  //     setTimeout(() => {
  //       next({
  //         path: '/home'
  //       })
  //     }, 200);
     
  //   }
  //   else if (token) {
  //     next()
  //   }
  //   else {
  //     setTimeout(() => {
  //         window.location.href='http://emergency.ai.assistant.web.guanyingis.com/#/login'
  //       }, 500);
  //   }
  // } else {
    next()
  // }
})
export default router;
